import { useKV } from "@/hooks/use-kv-adapter";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Play } from "@phosphor-icons/react";

export function MyLearning() {
  // Mock enrollments
  const [enrollments] = useKV<any[]>("lms-enrollments", [
    {
      id: "101",
      courseTitle: "React Fundamentals",
      progress: 45,
      lastAccessed: new Date().toISOString()
    }
  ]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {enrollments.map((enrollment) => (
          <Card key={enrollment.id}>
            <CardHeader>
              <CardTitle>{enrollment.courseTitle}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>Progress</span>
                  <span>{enrollment.progress}%</span>
                </div>
                <Progress value={enrollment.progress} />
              </div>
              <p className="text-xs text-slate-500">Last accessed: {new Date(enrollment.lastAccessed).toLocaleDateString()}</p>
            </CardContent>
            <CardFooter>
              <Button className="w-full gap-2">
                <Play className="w-4 h-4" /> Continue Learning
              </Button>
            </CardFooter>
          </Card>
        ))}
        {enrollments.length === 0 && (
          <div className="col-span-full text-center py-12 text-slate-500">
            You haven't enrolled in any courses yet.
          </div>
        )}
      </div>
    </div>
  );
}
